import { render, staticRenderFns } from "./AdminWorkspaceGroupPopup.vue?vue&type=template&id=dc3a4610&scoped=true&"
import script from "./AdminWorkspaceGroupPopup.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaceGroupPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminWorkspaceGroupPopup.vue?vue&type=style&index=0&id=dc3a4610&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3a4610",
  null
  
)

export default component.exports